import Signal from '@signals/Signal.js';

export const viewChange = new Signal();
// Signal for when selection mode is toggled
export const selectionModeChanged = new Signal();
// Signal for selection actions (reply, copy, edit, delete, react)
export const selectionActionChanged = new Signal();
